<template>
  <b-modal
    id="switchAgence"
    modal-class="giga-modal"
    dialog-class="modal-lg"
    content-class="text-center pb-2"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    lazy
  >
    <div class="gigawhat-modal">
      <div class="modal-heading" style="margin-bottom: 0">
        <h2 class="modal-title">Choix d'agence</h2>
        <p class="modal-description">
          Choisir l'agence à laquelle vous souhaiter accéder
        </p>
      </div>
      <div class="modal-body giga-fields">
        <div class="giga-input_field">
          <div class="input-field_area" style="width: 300%">
            <multiselect
              id="switchAgenceHeader"
              v-select-overflow
              v-model="getCurrentUser.agence"
              :options="getCurrentUser.agences"
              label="raisonSocial"
              open-direction="bottom"
              :searchable="true"
              :multiple="false"
              :close-on-select="true"
              :allow-empty="false"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.raisonSocial }}
              </template>
              <template slot="option" slot-scope="{ option }">
                {{ option.raisonSocial }}
              </template>
              <template slot="caret">
                <div
                  class="multiselect__select d-flex align-items-center justify-content-center"
                >
                  <div>
                    <b-icon icon="chevron-down"></b-icon>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="gigwhat-model_footer" style="margin-top: 0">
        <div class="half-footer left-content"></div>
        <div class="half-footer right-content">
          <div class="giga-button">
            <button
              id="btn-submit"
              class="giga-green_button no-icon"
              @click="saveAgence()"
            >
              {{ $t("submit") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { userService } from "@/views/service/user.service";
import store from "@/store";

export default {
  name: "UserAgence",
  computed: {
    ...mapGetters("account", ["getCurrentUser"])
  },
  methods: {
    ...mapActions("notification", ["closeModal"]),
    saveAgence() {
      const data = {
        id: this.getCurrentUser.id,
        lastName: this.getCurrentUser.lastName,
        clientType: this.getCurrentUser.clientType,
        firstName: this.getCurrentUser.firstName,
        email: this.getCurrentUser.email,
        phoneNumber: this.getCurrentUser.phoneNumber,
        username: this.getCurrentUser.username,
        isEnabled: this.getCurrentUser.isEnabled,
        admin: this.getCurrentUser.isAdmin,
        role: this.getCurrentUser.role,
        agence: this.getCurrentUser.agence
      };
      userService.modifyUserActiveAgence(data).then(() => {
        this.closeModal({ instance: this.$root, id: "switchAgence" });
        store.commit("account/setSwitchAgence");

        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    }
  }
};
</script>

<style scoped lang="scss">
#switchAgenceHeader {
  display: flex;
  flex-direction: column;
  order: -1;
  width: 100px;
  height: 55%;
  padding: 8px;
  border: 0px !important;
  border-radius: 5px;
  margin-bottom: 5px;
}

.multiselect--active {
  position: relative !important;
}
</style>
